import React from "react";
import styled from "styled-components";

import { colors } from "utils";

// A link to one of the rubric documents, always in a new tab.
//
// "toolbar" is the Sessions tab's "View:" row, drawn as the frame's Button/Text
// Only: regular 18px text, no underline, the design's 24px glyph before the
// text. "inline" sits inside a paragraph, as the Dosage & Collaboration
// description draws it: underlined, at the paragraph's own weight and size,
// with the same glyph after the text.
export const RubricLink = ({ href, variant = "toolbar", children }) =>
  variant === "inline" ? (
    <InlineLink href={href} target="_blank" rel="noopener noreferrer">
      {children}
      <Glyph />
    </InlineLink>
  ) : (
    <ToolbarLink href={href} target="_blank" rel="noopener noreferrer">
      <ToolbarGlyph />
      <ToolbarText>{children}</ToolbarText>
    </ToolbarLink>
  );

// The frame's own external-link glyph, drawn as exported.
const ExternalLinkGlyph = ({ className }) => (
  <svg
    className={className}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    aria-hidden="true"
  >
    <path
      d="M21 13V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V5C3 4.46957 3.21071 3.96086 3.58579 3.58579C3.96086 3.21071 4.46957 3 5 3H11M21 3L12 12M21 9V3H15"
      stroke={colors.blue700}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const ToolbarLink = styled.a`
  display: inline-flex;
  align-items: center;
  box-sizing: border-box;
  height: 48px;
  padding: 0 16px 0 8px;
  border-radius: 6px;
  font-family: "Inter", sans-serif;
  font-size: 18px;
  font-weight: 400;
  line-height: 26px;
  letter-spacing: 0.25px;
  color: ${colors.blue700};
  text-decoration: none;

  &:hover,
  &:focus {
    color: ${colors.blue700};
    text-decoration: none;
  }

  &:hover > span,
  &:focus > span {
    text-decoration: underline;
  }
`;

const ToolbarText = styled.span`
  padding: 0 4px;
`;

const ToolbarGlyph = styled(ExternalLinkGlyph)`
  flex-shrink: 0;
`;

const InlineLink = styled.a`
  color: ${colors.blue700};
  font-size: inherit;
  font-weight: inherit;
  text-decoration: underline;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;

  &:hover,
  &:focus {
    color: ${colors.blue700};
  }
`;

// 1px below the top of its 26px line, as the frame places it.
const Glyph = styled(ExternalLinkGlyph)`
  display: inline-block;
  margin-left: 8px;
  margin-top: 1px;
  vertical-align: top;
`;
